import { render, staticRenderFns } from "./AvatarInitials.vue?vue&type=template&id=33a93c3a&"
import script from "./AvatarInitials.vue?vue&type=script&lang=js&"
export * from "./AvatarInitials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports